import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { testimonialImages } from '../../data/testimonials';
export function Testimonials() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const goToIndex = (index: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(index, testimonialImages.length - 1));
    const card = track.children[clamped] as HTMLElement | undefined;
    if (!card) return;
    const maxScroll = track.scrollWidth - track.clientWidth;
    const target = Math.min(card.offsetLeft - track.offsetLeft, maxScroll);
    track.scrollTo({
      left: target,
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    let frame: number;
    const handleScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const cards = Array.from(track.children) as HTMLElement[];
        let closest = 0;
        let minDistance = Infinity;
        cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            closest = i;
          }
        });
        setActiveIndex(closest);
      });
    };
    track.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      track.removeEventListener('scroll', handleScroll);
      cancelAnimationFrame(frame);
    };
  }, []);
  const isFirst = activeIndex === 0;
  const isLast = activeIndex === testimonialImages.length - 1;
  return <section className="bg-paper py-14 sm:py-20" data-id="element-208" data-mp="r3jwb5szb6wp">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-209" data-mp="r54ud5ei57zb">
        <SectionTag icon="💬" tone="accent" data-id="element-210" data-mp="m3xjgxh2bsof">
          Comentarios reales
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-211" data-mp="nl4fij8v1b6v">
          Así están usando el material las instructoras
        </h2>
      </div>

      <div className="mx-auto mt-10 max-w-4xl px-3 sm:px-6" data-id="element-212" data-mp="eky0uu1fe564">
        <div ref={trackRef} className="scrollbar-hide flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth sm:gap-6" data-id="element-213" data-mp="ekoc19s4a420">
          {testimonialImages.map(testimonial => <div key={testimonial.src} className="flex w-full flex-shrink-0 snap-center sm:w-[calc(50%-12px)]" data-id="element-214" data-mp="4t1u6ul9x6qa">
              <img src={testimonial.src} alt={testimonial.alt} loading="lazy" decoding="async" className="aspect-[450/538] w-full object-contain" data-id="element-215" data-mp="3r34g3dc36eag" />
            </div>)}
        </div>

        <div className="mt-5 flex items-center justify-center gap-5" data-id="element-216" data-mp="3n19bnzyuzksg">
          <button type="button" onClick={() => goToIndex(activeIndex - 1)} disabled={isFirst} aria-label="Testimonio anterior" className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/15 text-primary transition-colors duration-150 hover:bg-primary/5 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-217" data-mp="3n2kgm341iyl5">
            <ChevronLeftIcon size={18} data-id="element-218" data-mp="3mdtup4gacdt7" />
          </button>

          <div className="flex items-center gap-2" role="tablist" aria-label="Seleccionar testimonio" data-id="element-219" data-mp="3mc92hlhg16yi">
            {testimonialImages.map((testimonial, i) => <button key={testimonial.src} type="button" role="tab" aria-label={`Ir al testimonio ${i + 1}`} aria-selected={activeIndex === i} onClick={() => goToIndex(i)} className={`h-2 rounded-full transition-colors duration-150 ${activeIndex === i ? 'w-5 bg-accent' : 'w-2 bg-primary/20 hover:bg-primary/40'}`} data-id="element-220" data-mp="3w452x370595w" data-mpi={i} />)}
          </div>

          <button type="button" onClick={() => goToIndex(activeIndex + 1)} disabled={isLast} aria-label="Testimonio siguiente" className="flex h-10 w-10 items-center justify-center rounded-full border border-primary/15 text-primary transition-colors duration-150 hover:bg-primary/5 disabled:opacity-30 disabled:hover:bg-transparent" data-id="element-221" data-mp="23e42d7x0ngcj">
            <ChevronRightIcon size={18} data-id="element-222" data-mp="1khb7x8c449gm" />
          </button>
        </div>
      </div>
    </section>;
}